import React from 'react';

const ContactCardRecord = ({ title, value }: { title: string; value: string }) => {
  if (!value || value.trim() === '') {
    return null;
  }

  return (
    <p className='c-contact-card-record'>
      <span className='is-block'>
        {title}: {value}
      </span>
    </p>
  );
};

export const ContactCard = ({ office }) => (
  <div className='c-contact-card is-office'>
    <p className='c-contact-card-name'>{office.OfficeName}</p>
    <ContactCardRecord title='Address1' value={office.Address1} />
    <ContactCardRecord title='Address2' value={office.Address2} />
    <ContactCardRecord title='Address3' value={office.Address3} />
    <span className='is-block'>
      {office.Postal} {office.City}
    </span>
    {office.PhoneNumber && office.PhoneNumber.trim() !== '' && (
    <p className='c-contact-card-record phone-p'>   
      <span className='is-block'>Phone: </span>
      <span className='phone-number-span'>
        {office.PhoneNumber.split(',').map((num: string, i: number) =>
          num.trim() !== '' ? (
            <React.Fragment key={`phone-${i}`}>
              <a href={'tel:' + `${num}`}>{num}</a>
              <br />
            </React.Fragment>
          ) : null
        )}
      </span>
    </p>
    )}
    <ContactCardRecord title='Fax' value={office.Fax} />
    {office.EmailAddress && office.EmailAddress.trim() !== '' && (
      <span className='is-block'>
        Email:{' '}
        <a className='word-break' href={'mailto:' + office.EmailAddress}>
          {office.EmailAddress}
        </a>
      </span>
    )}
  </div>
);
